/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlanNotes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlanNotes({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/PlanNotes",
  onChange
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let planDetailsDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'plan_details',
path: 'description',
})
let planDetailsDescriptionChangeData = fromData.useDataChange({ viewPath,
context: 'plan_details',
path: 'description',
})
  return (<React.Fragment
>
<div
  data-testid="PlanNotes.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-ZeK6wu': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 data="plan_details.description"
 value={planDetailsDescriptionValueData}
 onChange={planDetailsDescriptionChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Plan Notes"
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
</div>
{children}
</React.Fragment>)
}